import type { DataSourceAbstract } from '@lighthouse/core'
import type { RichTextEditorProps, SendMsgDingTalkRobotConfig, VariableTree2 } from '@lighthouse/shared'
import { RichTextEditor, tiptapJsonToMarkdown } from '@lighthouse/shared'
import type { JSONContent } from '@tiptap/core'
import React, { useCallback, useMemo } from 'react'

import { PersonConfig } from './PersonConfig'
import * as SC from './styles'

interface RichTextMsgConfigProps {
    userOption?: VariableTree2
    upstreamOptions: VariableTree2[]
    dataSourceList?: DataSourceAbstract[]
    value: SendMsgDingTalkRobotConfig
    onChange: (value: SendMsgDingTalkRobotConfig) => void
}

export const RichTextMsgConfig: React.FunctionComponent<RichTextMsgConfigProps> = ({
    userOption,
    upstreamOptions,
    dataSourceList,
    value,
    onChange
}) => {
    const config: RichTextEditorProps['config'] = useMemo(() => {
        return {
            variable: {
                userOption,
                upstreamOptions
            },
            mode: 'all'
        }
    }, [upstreamOptions, userOption])

    const handleChange = useCallback(
        (json: JSONContent) => {
            const markdown = tiptapJsonToMarkdown(json)
            onChange({
                ...value,
                markdown: {
                    title: value.markdown?.title || '',
                    text: markdown,
                    editorText: json
                }
            })
        },
        [onChange, value]
    )

    return (
        <>
            <SC.Item>
                <SC.Text>
                    消息内容
                    <SC.Text color="red" style={{ paddingLeft: 4 }}>
                        *
                    </SC.Text>
                </SC.Text>
                <RichTextEditor
                    config={config}
                    autofocus="end"
                    value={value.markdown?.editorText}
                    styles={{
                        editorContainer: {
                            minHeight: 200,
                            borderRadius: 6,
                            marginTop: 12,
                            border: '1px solid var(--color-gray-200)'
                        }
                    }}
                    disableToolbar={false}
                    onChange={handleChange}
                />
            </SC.Item>
            <PersonConfig
                userOption={userOption}
                upstreamOptions={upstreamOptions}
                dataSourceList={dataSourceList}
                value={value}
                onChange={onChange}
            />
        </>
    )
}
